import React from 'react';
import { Alert } from 'react-bootstrap';
import useHeader from 'containers/App/Header/useHeader';

function UnavailableAdminRoute() {
  useHeader('Admin');

  return (
    <div className="p-4">
      <Alert variant="warning">
        This admin page is no longer available from this URL.
      </Alert>
    </div>
  );
}

export default UnavailableAdminRoute;
